
const validaPhone = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
const validatePhone = (rule, value, callback) => {
    if (value == '') {
      callback(new Error('手机号不能为空'))
    } else {
      console.log(111)
      if (!validaPhone.test(value)) {
        callback(new Error('请输入有效的手机号码'));
        return;
      }
      callback()
    }
}

const validaNumber = (rlue, value, callback) => {
  if(!value) {
    callback(new Error('身份证不能为空'))
  } else {
    // var reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    var reg = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
              
    if (!reg.test(value)) {
      callback(new Error('请输入合法的身份证'));
      return;
    }
    callback()
  }
}
      
export default {
  validatePhone: validatePhone,
  validaNumber: validaNumber
}



// WEBPACK FOOTER //
// ./src/utils/pattern.js